import type { QuizQuestion } from "@core/features/quiz";
import type { ProcessedAnswer } from "../publicProfile.types";

/**
 * Process a quiz question to extract its answer data.
 */
export function processQuestion(question: QuizQuestion): ProcessedAnswer {
  const { id, prompt, internal_name, type, choices } = question;

  // Extract text answer
  const textValue = question.user_answer_text || undefined;

  // Extract selected choices by mapping user_answer IDs to display text
  let selectedChoices: string[] | undefined;
  if (question.user_answer && question.user_answer.length > 0 && choices) {
    selectedChoices = question.user_answer
      .map((choiceId) => {
        const choice = choices.find((c) => c.id === choiceId);
        return choice?.display_text;
      })
      .filter((text): text is string => Boolean(text));
  }

  // Extract uploaded media
  const uploadedMedia = question.user_uploaded_media?.length
    ? question.user_uploaded_media
    : undefined;

  // Determine if question has any answer
  const hasAnswer = Boolean(
    textValue ||
      (selectedChoices && selectedChoices.length > 0) ||
      (uploadedMedia && uploadedMedia.length > 0)
  );

  return {
    questionId: id,
    label: prompt,
    internalName: internal_name,
    type,
    textValue,
    selectedChoices,
    uploadedMedia,
    hasAnswer,
  };
}
